/* eslint-disable jsx-a11y/anchor-has-content */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import config from 'config';

import './share-links.css';

const makeLinks = (props) => {
  let fb = 'https://www.facebook.com/sharer/sharer.php?';
  let tw = 'https://twitter.com/share?';
  let gg = 'https://plus.google.com/share?';
  let vk = 'https://vkontakte.ru/share.php?';

  const url = encodeURIComponent(props.url ? props.url : `${config.appProtocol}://${config.appDomain}/`);

  fb += `u=${url}`;
  tw += `url=${url}`;
  gg += `url=${url}`;
  vk += `url=${url}`;

  if (props.title) {
    const title = encodeURIComponent(props.title);

    tw += `&text=${title}`;
    gg += `&title=${url}`;
    vk += `&title=${title}`;
  }

  if (props.img) {
    const img = encodeURIComponent(props.img);

    gg += `&image=${img}`;
    vk += `&image=${img}`;
  }

  if (props.description) {
    const description = encodeURIComponent(props.description);

    gg += `&description=${description}`;
    vk += `&description=${description}`;
  }

  return { fb, tw, gg, vk };
};

export class ShareLinks extends PureComponent {
  constructor(...args) {
    super(...args);
    this.linkClickHandler = this.onLinkClick.bind(this);
    this.socials = ['fb', 'tw', 'gg', 'vk'];
    this.state = makeLinks(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(makeLinks(nextProps));
  }

  onLinkClick(event) {
    event.preventDefault();
    window.open(event.target.href, '', 'toolbar=0,status=0,width=626,height=436');
  }

  render() {
    return (
      <ul className="share-links-list">
        {this.socials.map(el =>
          <li key={el}>
            <a
              href={this.state[el]}
              className={`share-link ${el}`}
              rel="noopener noreferrer"
              target="_blank"
              onClick={this.linkClickHandler}
            />
          </li>
        )}
      </ul>
    );
  }
}

ShareLinks.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  img: PropTypes.string,
  description: PropTypes.string
};

export default ShareLinks;



// WEBPACK FOOTER //
// ./src/widgets/ShareLinks/index.js